export { default as ModelNameField } from './component';
